import React from 'react'
import { useTranslation } from 'react-i18next'
import { DedicatedServerPrice, DedicatedServerPricePeriod } from '../../../api/bareMetalTypes'
import { Hint, Segment, SegmentGroup } from './ui'

export type PricePeriod = Extract<DedicatedServerPricePeriod, 'day' | 'month'>

export function PricePeriodSelector({ value, onChange }: { value: PricePeriod; onChange: (period: PricePeriod) => void }) {
  const [t] = useTranslation()
  return <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end', gap: 8, margin: '6px 0 14px' }}>
    <Hint>{t('DEDICATED_PRICE_PERIOD')}</Hint>
    <SegmentGroup role="group" aria-label={String(t('DEDICATED_PRICE_PERIOD'))}>
      {(['day', 'month'] as const).map(period => <Segment key={period} type="button" $active={value === period}
        aria-pressed={value === period} onClick={() => onChange(period)}>
        {t(period === 'day' ? 'DEDICATED_PRICE_DAY' : 'DEDICATED_PRICE_MONTH')}
      </Segment>)}
    </SegmentGroup>
  </div>
}

export default function Price({ price, period, loading = false }: { price?: DedicatedServerPrice | null; period: PricePeriod; loading?: boolean }) {
  const [t] = useTranslation()
  return <span>{loading ? t('LOADING') : price
    ? `${price.total} ${price.currency} ${t(period === 'day' ? 'DEDICATED_PER_DAY' : 'MONTH')}`
    : t('DEDICATED_PRICE_UNAVAILABLE')}</span>
}
